import React from "react";
import type { RootStore } from "./RootStore";

/**
 * React Context for the RootStore
 * Provides access to all stores throughout the component tree
 */
const StoreContext = React.createContext<RootStore | null>(null);

export default StoreContext;

